import { Tabs, Card, Row, Col, Table, Button, Tag, Form, Modal, Skeleton, Input, Dropdown, Select, Menu, Image, AutoComplete, Checkbox } from "antd";
import axiosClient from "../../api/axios";
import { useEffect, useState, useRef } from "react";
import {
    SearchOutlined, SettingOutlined, EditOutlined, PicCenterOutlined, MenuOutlined, PlusOutlined, AppstoreOutlined, ArrowLeftOutlined, PlusSquareOutlined, UserOutlined, PhoneFilled, MailFilled, FileExcelOutlined, DeleteOutlined, TeamOutlined, FormOutlined, SkinOutlined, CheckOutlined
} from "@ant-design/icons";
import swal from "sweetalert";
import { Route, useLocation, Switch, useHistory } from 'react-router-dom';
import moment from "moment";

const { Option } = Select
const Decentralization = () => {
    const refTable = useRef(null);
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('Role');

    const user = {
        "ID": localStorage.getItem('ID'),
        "Role": localStorage.getItem('Role'),
        "UserName": localStorage.getItem('UserName'),
        "FullName": localStorage.getItem('FullName'),
        "Password": localStorage.getItem('Password'),
        "Phone": localStorage.getItem('Phone'),
        "Email": localStorage.getItem('Email'),
        "Image": localStorage.getItem('Image'),
        "Active": true,
        "DatabaseName": localStorage.getItem('DatabaseName'),
        "SecurityCode": localStorage.getItem('SecurityCode'),
        "ExpirationDate": localStorage.getItem('ExpirationDate')
    }
    // ------------User Group----------------
    const [dataUserGroup, setDataUserGroup] = useState([]);

    // --------------- Detial Funtion---------------
    const [dataDetailFuntion, setDataDetailFuntion] = useState([]);
    const [openModalDetailFuntion, setOpenModalDetailFuntion] = useState(false);
    const [loadingDetialFuntion, setLoadingDetailFuntion] = useState(false);
    const [statusDetailFuntion, setStatusDetailFuntion] = useState(false);
    const [formDetailFuntion] = Form.useForm();

    // ----------------Account-----------------------
    const [dataAccount, setDataAccount] = useState([]);
    const [openModalAccount, setOpenModalAccount] = useState(false);
    const [loadingAccount, setLoadingAccount] = useState(false);
    const [statusAccount, setStatusAccount] = useState(false);
    const [formAccount] = Form.useForm();
    // ---------------Permissions--------------
    const [dataPermissions, setDataPermissions] = useState([]);
    const [openModalPermissions, setOpenModalPermissions] = useState(false);
    const [loadingPermissions, setLoadingPermissions] = useState(false);
    const [statusPermissions, setStatusPermissions] = useState(false);
    const [formPermissions] = Form.useForm();
    const [columnPermissions, setColumnPermissions] = useState([])
    // ---------------Account Permissions ----------------------
    const [dataAccountPermiss, setDataAccountPermiss] = useState([]);
    const [openModalAccountPermiss, setOpenModalAccountPermiss] = useState(false);
    const [loadingAccountPermiss, setLoadingAccountPermiss] = useState(false);
    const [statusAccountPermiss, setStatusAccountPermiss] = useState(false);
    const [formAccountPermiss] = Form.useForm();


    // header
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    //data
    const [dataDecentralization, setDataDecentralization] = useState([]);
    const [dataDecentralizationInit, setDataDecentralizationInit] = useState([]);
    // form
    const [formDecentralization] = Form.useForm();
    const [formFilterDecentralization] = Form.useForm();
    // state
    const [loading, setLoading] = useState(false);
    const [openModalDecentralization, setOpenModalDecentralization] = useState(false);
    const [statusModalDecentralization, setStatusModalDecentralization] = useState(false);
    // functions


    const loadDataDecentralization = () => {
        axiosClient.post('/FunctionGroups/GetFunctionGroupAndDetailFunction', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                axiosClient.post('/DetailFunctions/GetDetailFunctionsAll', '', { headers: header }).then(resd => {
                    const item = res.data.map(r => r.functionGroup).map(i => ({
                        ID: i.ID,
                        IDFunctionGroup: i.ID,
                        FunctionName: i.FunctionName,
                        ApiName: '',

                    }))
                    setDataDecentralizationInit(item)
                    setDataDecentralization(item);
                })
            }
        })

    }

    const changeUpdatePermissAccount = (e, idPermiss, idGroupPermission, IDDetailFunction) => {
        // xử lý check update

        if (idPermiss === 0) {
            axiosClient.post('/Permissions/AddPermissions', {
                "ID": 1,
                "IDDetailFunction": IDDetailFunction,
                "IDGroupPermission": idGroupPermission,
                "Allow": e.target.checked
            }, { headers: header }).then(res => {
                swal('Cập nhật thành công!', {
                    icon: 'success',
                })

                setStatus(!status)
            })
        }
        else {
            axiosClient.post('/Permissions/UpdatePermissions', {
                "ID": idPermiss,
                "IDDetailFunction": IDDetailFunction,
                "IDGroupPermission": idGroupPermission,
                "Allow": e.target.checked
            }, { headers: header }).then(res => {
                swal('Cập nhật thành công!', {
                    icon: 'success',
                })

                setStatus(!status)
            })
        }


    }
    const columnTempPermissions = [];
    const columnTempDetailPermiss = [];
    const LoadColumnPermissions = () => {
        axiosClient.post(`/FunctionGroups/GetFunctionGroupAndDetailFunction`, '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                const item = res.data.map(r => r.functionGroup).map(i => ({
                    ID: i.ID,
                    IDFunctionGroup: i.ID,
                    FunctionName: i.FunctionName,
                    ApiName: '',
                }))
                setDataDecentralization(item);
                axiosClient.post('/GroupPermissions/GetGroupPermissionsAll', '', { headers: header }).then(resGroup => {
                    axiosClient.post('/Permissions/GetPermissionsAll', '', { headers: header }).then(resPermiss => {
                        if (resPermiss.status === 200) {

                            // thêm dữ liệu cột ngang
                            resGroup.data.forEach(element => {
                                columnTempPermissions.push({
                                    title: <div style={{ textAlign: 'center' }}>
                                        <strong>{element.GroupName}</strong>
                                    </div>,
                                    width: 100,
                                    render: (text, record) => {
                                        return (
                                            <div>
                                                {record.GroupName}
                                            </div>
                                        )
                                    }
                                });
                            });
                            columnTempPermissions.unshift({
                                title: 'Chức năng',
                                width: 300,
                                render: (text, record) => {
                                    return (
                                        <div >
                                            <strong>{record.FunctionName}</strong>
                                        </div>
                                    )
                                }
                            },);
                            setColumnPermissions(columnTempPermissions);
                            // columnDetail Permiss
                            resGroup.data.forEach(element => {
                                columnTempDetailPermiss.push({
                                    title: <div style={{ textAlign: 'center' }}>
                                        <strong>{element.GroupName}</strong>
                                    </div>,
                                    width: 100,
                                    render: (text, record) => {
                                        let allow = false;
                                        let id = 0;
                                        resPermiss.data.filter(i => i.IDGroupPermission === element.ID && i.IDDetailFunction === record.ID).forEach(({ Allow, ID }) => {
                                            allow = Allow;
                                            id = ID
                                        });

                                        return (
                                            <div style={{ textAlign: 'center' }}>
                                                <Checkbox checked={allow} onChange={(e) => changeUpdatePermissAccount(e, id, element.ID, record.ID)} />
                                            </div>
                                        )
                                    }
                                });
                            });
                            columnTempDetailPermiss.unshift(
                                {
                                    title: <div style={{ textAlign: 'center' }}>
                                        Chức năng
                                    </div>,
                                    dataIndex: 'DetailName',
                                    width: 300,
                                }
                            )
                            setColumnsDetailPermiss(columnTempDetailPermiss)

                        }
                    })
                })


            }
        })
    }

    const LoadDataDetailFuntion = () => {
        axiosClient.post('/DetailFunctions/GetDetailFunctionsAll', '', { headers: header }).then(res => {
            if (res.status === 200) {
                setDataDetailFuntion(res.data);
            }
        })
    }

    const detailFuntion = (id) => {
        const data = dataDetailFuntion.filter(i => i.IDFunctionGroup === id).map((r, index) => ({
            ID: r.ID,
            IDFunctionGroup: r.IDFunctionGroup,
            DetailName: r.DetailName,
            ApiName: r.ApiName,
            STT: index + 1
        }))
        return data
    }


    const LoadDataAccountPermiss = () => {
        axiosClient.post('/AccountPermissions/GetAccountPermissionsAll', '', { headers: header }).then(res => {
            if (res.status === 200) {
                setDataAccountPermiss(res.data.filter(i => i.IDGroupPermission !== 0));
            }
        })
    }

    const LoadDataPermissions = () => {
        axiosClient.post('/GroupPermissions/GetGroupPermissionsAll', '', { headers: header }).then(res => {
            if (res.status === 200) {
                setDataPermissions(res.data);
            }
        })
    }

    const loadDataAccount = () => {
        axiosClient.post('/Accounts/SubGetAccountsAll', user, {
            headers: header
        }).then(res => {
            if (res.status === 200) {

                if (res.data === null) {
                    setDataAccount(dataAccount);
                }
                else {

                    setDataAccount(res.data);
                }

            }
        })
    }
    const [status, setStatus] = useState(false);

    useEffect(() => {
        LoadDataAccountPermiss();
        loadDataAccount()

        LoadColumnPermissions()
        LoadDataPermissions();
        LoadDataDetailFuntion()
        loadDataDecentralization();
    }, [status])
    const rowSelectionUserGroup = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: record => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
    };
    const showModalDetailFuntion = (record) => {
        if (record !== 0) {
            setStatusDetailFuntion(false);
            setOpenModalDetailFuntion(true)
            formDetailFuntion.setFieldsValue({
                "IDFunctionGroup": record
            })
        }
    }
    const showModalUpdateDetailFuntion = (record) => {
        if (record.ID !== 0) {
            setStatusDetailFuntion(true);
            setOpenModalDetailFuntion(true);
            formDetailFuntion.setFieldsValue(record)
        }
    }
    const menuDecentralization = (record) => (
        <Menu>
            <Menu.Item onClick={(e) => showModalDecentralization(record.ID)} key="0">
                <h3>Cập nhật</h3>
            </Menu.Item>
            <Menu.Item disabled={role.toLowerCase().includes('admin') ? false : true} onClick={(e) => showModalDetailFuntion(record.ID)} key="2">
                <h3 style={{ color: role.toLowerCase().includes('admin') ? null : '#C0C0C0' }}>Thêm phân quyền chi tiết</h3>
            </Menu.Item>
            <Menu.Item disabled={role.toLowerCase().includes('admin') ? false : true} onClick={(e) => handleDelete(record.ID)} key="3">
                <h3 style={{ color: role.toLowerCase().includes('admin') ? null : '#C0C0C0' }}>Xóa</h3>
            </Menu.Item>
        </Menu>
    );
    const menuDetailFuntion = (record) => (
        <Menu>
            <Menu.Item onClick={(e) => showModalUpdateDetailFuntion(record)} key="0">
                <h3>Cập nhật</h3>
            </Menu.Item>
            <Menu.Item disabled={role.toLowerCase().includes('admin') ? false : true} onClick={(e) => DeleteFuntionDetail(record.ID)} key="3">
                <h3 style={{ color: role.toLowerCase().includes('admin') ? null : '#C0C0C0' }}>Xóa</h3>
            </Menu.Item>
        </Menu>
    );
    const rowSelectionDecentralization = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        getCheckboxProps: record => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
    };
    const columnsDecentralization = [

        {
            title: <div style={{ textAlign: 'center' }}>
                #
            </div>,
            width: 50,
            key: "STT",
            dataIndex: 'STT',
        },
        {
            title: <div style={{ textAlign: 'center' }}>
                Tên phân quyền
            </div>,
            dataIndex: 'FunctionName',
            width: 400,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.ApiName === '' ? <strong>{record.FunctionName}</strong> : <p>{record.FunctionName}</p>}
                    </div>
                );
            },
        },
        {
            title: <div style={{ textAlign: 'center' }}>
                Api
            </div>,
            dataIndex: 'ApiName',
            width: 220
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Dropdown
                            overlay={menuDecentralization(record)}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <div style={{ textAlign: 'center' }}>
                                <Button type="text"><AppstoreOutlined style={{ color: '#FF0000', fontSize: 18 }} /></Button>
                            </div>
                        </Dropdown>
                    </div>
                );
            },
        },
    ]
    const [columnsDetailPermiss, setColumnsDetailPermiss] = useState([])

    const columnsDetail = [
        {
            title: <div style={{ textAlign: 'center' }}>
                #
            </div>,
            dataIndex: 'ID',
            width: 50,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.STT}
                    </div>
                );

            },
        },
        {
            title: <div style={{ textAlign: 'center' }}>
                Tên phân quyền
            </div>,
            dataIndex: 'DetailName',
            width: 401,
        },
        {
            title: <div style={{ textAlign: 'center' }}>
                Api
            </div>,
            dataIndex: 'ApiName',
            width: 220,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {record.ApiName}
                    </div>
                );

            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Dropdown
                            overlay={menuDetailFuntion(record)}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <div style={{ textAlign: 'center' }}>
                                <Button type="text"><MenuOutlined style={{ color: '#2db7f5', fontSize: 18 }} /></Button>
                            </div>
                        </Dropdown>
                    </div>
                );
            },
        },
    ]

    const columnsUserGroup = [
        {
            title: 'ID',
            dataIndex: 'FunctionName',
            width: 50,
            render: (text, record) => {
                return (
                    <div >
                        {record.ID}
                    </div>
                );
            },
        },
        {
            title: 'Nhóm quyền',
            dataIndex: 'FunctionName',
            render: (text, record) => {
                return (
                    <div >
                        {record.GroupName}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Button.Group>
                            <Button
                                onClick={(e) => {
                                    showModalPermiss(record.ID, e);
                                }}
                                icon={<EditOutlined style={{ color: "#33CCFF" }} />}
                            ></Button>
                            &ensp;
                            <Button
                                onClick={(e) => {
                                    handleDeletePermiss(record.ID);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </Button.Group>
                    </div>
                );
            },
        },
    ]
    const columnsAccountPermiss = [
        {
            title: 'Tên người dùng',
            width: 300,
            render: (text, record) => {
                return (
                    <div >
                        {dataAccount.filter(i => i.ID === record.IDAccount).map(r => r.FullName)}
                    </div>
                );
            },
        },
        {
            title: 'Nhóm người dùng',
            dataIndex: 'FunctionName',
            width: 300,
            render: (text, record) => {
                return (
                    <div >
                        {dataPermissions.filter(i => i.ID === record.IDGroupPermission).map(r => r.GroupName)}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <SettingOutlined />
                </div>
            ),
            width: 120,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        <Button.Group>
                            <Button
                                onClick={(e) => {
                                    showModalAccountPermiss(record.ID, e);
                                }}
                                icon={<EditOutlined style={{ color: "#33CCFF" }} />}
                            ></Button>
                            &ensp;
                            <Button
                                onClick={(e) => {
                                    handleDeleteAccountPermiss(record.ID);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button>
                        </Button.Group>
                    </div>
                );
            },
        },
    ]
    const resetForm = () => {
        formDecentralization.resetFields()
    }
    const handleOk = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setOpenModalDecentralization(false);
        }, 3000);
    }
    const handleCancel = () => {
        resetForm();
        setLoading(false);
        setOpenModalDecentralization(false);
    }
    const handleOkDetialFuntion = () => {
        setLoadingDetailFuntion(true);
        setTimeout(() => {
            setLoadingDetailFuntion(false);
            setOpenModalDetailFuntion(false);
        }, 3000);
    }
    const handleCancelDetialFuntion = () => {
        formDetailFuntion.resetFields();
        setLoadingDetailFuntion(false);
        setOpenModalDetailFuntion(false);
    }
    const handleOkAccountPermiss = () => {
        setLoadingAccountPermiss(true);
        setTimeout(() => {
            setLoadingAccountPermiss(false);
            setOpenModalAccountPermiss(false);
        }, 3000);
    }
    const handleCancelAccountPermiss = () => {
        formAccountPermiss.resetFields();
        setLoadingAccountPermiss(false);
        setOpenModalAccountPermiss(false);
    }
    const handleOkAccount = () => {
        setLoadingAccount(true);
        setTimeout(() => {
            setLoadingAccount(false);
            setOpenModalAccount(false);
        }, 3000);
    }
    const handleCancelAccount = () => {
        formAccount.resetFields();
        setLoadingAccount(false);
        setOpenModalAccount(false);
    }
    const handleOkPermissions = () => {
        setLoadingPermissions(true);
        setTimeout(() => {
            setLoadingPermissions(false);
            setOpenModalPermissions(false);
        }, 3000);
    }
    const handleCancelPermissions = () => {
        formPermissions.resetFields();
        setLoadingPermissions(false);
        setOpenModalPermissions(false);
    }
    const checkFilter = (values) => {
        // kiểm tra tham số truyền vào khi lọc tìm kiếm
        var InfoUser = values.InfoUser;
        var RoleFilter = values.RoleFilter;
        var result = 0;
        if (values.InfoUser === undefined) {
            InfoUser = "";
        }
        if (values.RoleFilter === undefined) {
            RoleFilter = "default";
        }
        // console.log(`InfoUser : ${InfoUser} và RoleFilter : ${RoleFilter}`);

        // trường hợp chỉ nhập Infouser trả về status filter = 1
        if (InfoUser !== "" && RoleFilter === "default") {
            result = 1;
        }
        if (InfoUser === "" && RoleFilter !== "default") {
            result = 2;
        }
        if (InfoUser !== "" && RoleFilter !== "default") {
            result = 3;
        }
        if (InfoUser === "" && RoleFilter === "default") {
            result = 4;
        }
        return result;
    };
    const onFinishFilter = (values) => {
        // lọc tìm kiếm
        console.log(values)
        if (values.ID === null || values.ID === undefined || values.ID === 'default') {
            loadDataDecentralization()
        } else {
            setDataDecentralization(dataDecentralization.filter(i => i.ID === values.ID));
        }

    }
    const onFinishDecentralization = (values) => {
        setLoading(true)
        if (statusModalDecentralization === false) {
            axiosClient.post('/FunctionGroups/AddFunctionGroups', values, { headers: header }).then(res => {
                if (res.status === 200) {
                    formDecentralization.resetFields();
                    swal('Thành công!', {
                        icon: 'success',
                        timer: 3000
                    })
                    loadDataDecentralization()
                    setLoading(false)
                    setOpenModalDecentralization(false);
                }
            })
        }
        else {
            axiosClient.post('/FunctionGroups/UpdateFunctionGroups', values, { headers: header }).then(res => {
                if (res.status === 200) {
                    formDecentralization.resetFields();
                    swal('Thành công!', {
                        icon: 'success',
                        timer: 3000
                    })
                    loadDataDecentralization()
                    setLoading(false)
                    setOpenModalDecentralization(false);
                }
            })
        }

    }
    const handleDelete = (record) => {
        setLoading(true)
        if (record !== 0) {
            swal({
                title: "Bạn có muốn xóa phân quyền này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/FunctionGroups/DeleteFunctionGroups/${record}`, { ID: record }, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                loadDataDecentralization();
                                setLoading(false)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const handleDeleteAccountPermiss = (record) => {
        setLoadingAccountPermiss(true)
        if (record !== 0) {
            swal({
                title: "Bạn có muốn xóa phân quyền người dùng này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/AccountPermissions/DeleteAccountPermissions/${record}`, { ID: record }, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataAccountPermiss();
                                setLoadingAccountPermiss(false)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const handleDeletePermiss = (record) => {
        setLoadingPermissions(true)
        if (record !== 0) {
            swal({
                title: "Bạn có muốn xóa nhóm người dùng này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/GroupPermissions/DeleteGroupPermissions/${record}`, { ID: record }, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                setStatus(!status)
                                setLoadingPermissions(false)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const DeleteFuntionDetail = (record) => {
        setLoadingDetailFuntion(true)
        if (record !== 0) {
            swal({
                title: "Bạn có muốn xóa phân quyền này?",
                icon: "warning",
                dangerMode: true,
                buttons: true
            })
                .then(willDelete => {
                    if (willDelete) {
                        axiosClient.post(`/DetailFunctions/DeleteDetailFunctions/${record}`, { ID: record }, { headers: header }).then(res => {
                            if (res.status === 200) {
                                swal("Xóa thành công", {
                                    icon: 'success'
                                });
                                LoadDataDetailFuntion();
                                setLoadingDetailFuntion(false)
                            }
                        })
                    }
                    else {
                        swal('Hủy thành công', {
                            icon: 'success'
                        })
                    }
                });
        }
    }
    const showModalDecentralization = (record) => {
        //const IDTemp = 0;
        resetForm();
        if (record === 0) {
            // thêm mới

            setStatusModalDecentralization(false);
            setOpenModalDecentralization(true);
        }
        else {
            // cập nhật
            setStatusModalDecentralization(true);
            setOpenModalDecentralization(true);
            const data = dataDecentralization.filter(i => i.ID === record);
            formDecentralization.setFieldsValue({
                FunctionName: data[0].FunctionName,
                ID: data[0].ID
            })

        }
    }
    const showModalAccountPermiss = (record) => {
        //const IDTemp = 0;
        formAccountPermiss.resetFields();
        if (record === 0) {
            // thêm mới
            setStatusAccountPermiss(false);
            setOpenModalAccountPermiss(true);
        }
        else {
            // cập nhật
            setStatusAccountPermiss(true);
            setOpenModalAccountPermiss(true);
            const data = dataAccountPermiss.filter(i => i.ID === record);
            formAccountPermiss.setFieldsValue({
                "ID": data[0].ID,
                "IDAccount": data[0].IDAccount,
                "IDGroupPermission": data[0].IDGroupPermission,
                Account: dataAccount.filter(i => i.ID === data[0].IDAccount).map(r => r.FullName),
                GroupPermission: dataPermissions.filter(i => i.ID === data[0].IDGroupPermission).map(r => r.GroupName),
            })
        }
    }

    const renderDecentralization = () => {
        return (
            <Form
                id="form-Decentralization"
                form={formDecentralization}
                onFinish={onFinishDecentralization}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>
                <Form.Item hidden name={'IDFunctionGroup'} >
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Nhập tên phân quyền",
                    },
                ]} name={'FunctionName'} label='Phân quyền' >
                    <Input />
                </Form.Item>

            </Form>
        )
    }
    const onFinishAccountPermiss = (values) => {

        if (statusAccountPermiss === false) {
            axiosClient.post('/AccountPermissions/AddAccountPermissions', values, { headers: header }).then(res => {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });
                LoadColumnPermissions()
                setStatus(!status);
                formAccountPermiss.resetFields();
                setDataAccountPermiss(false)
                setOpenModalAccountPermiss(false)
            })
        }
        else {

            axiosClient.post('/AccountPermissions/UpdateAccountPermissions', values, { headers: header }).then(res => {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });

                LoadColumnPermissions()
                setStatus(!status);
                formAccountPermiss.resetFields();
                setDataAccountPermiss(false)
                setOpenModalAccountPermiss(false)
            })
        }
    }
    const changeAccountPermiss = (value, child) => {

        formAccountPermiss.setFieldsValue({
            IDAccount: Number(child.key)
        })
    }
    const changeGroupPermiss = (value, child) => {

        formAccountPermiss.setFieldsValue({
            IDGroupPermission: Number(child.key)
        })
    }
    const renderAccountPermiss = () => {
        return (
            <Form
                id="form-AccountPermiss"
                form={formAccountPermiss}
                onFinish={onFinishAccountPermiss}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>
                <Form.Item hidden name={'IDAccount'} >
                    <Input />
                </Form.Item>
                <Form.Item hidden name={'IDGroupPermission'} >
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Chọn người dùng",
                    },
                ]} name={'Account'} label='Người dùng' >
                    <Select onChange={changeAccountPermiss} showSearch>
                        {dataAccount.map(r => (
                            <Option key={r.ID} value={r.FullName}>
                                {r.FullName}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Chọn nhóm quyền",
                    },
                ]} name={'GroupPermission'} label='Nhóm quyền' >
                    <Select onChange={changeGroupPermiss} showSearch>
                        {dataPermissions.map(r => (
                            <Option key={r.ID} value={r.GroupName}>
                                {r.GroupName}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        )
    }
    const onFinishPermissions = (values) => {
        setLoadingPermissions(true)
        if (statusPermissions === false) {
            axiosClient.post('/GroupPermissions/AddGroupPermissions', values, { headers: header }).then(res => {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });
                LoadDataPermissions()
                formPermissions.resetFields();
                setLoadingPermissions(false)
                setOpenModalPermissions(false)
            })
        }
        else {
            axiosClient.post('/GroupPermissions/UpdateGroupPermissions', values, { headers: header }).then(res => {
                swal('Thành công!', {
                    icon: 'success',
                    timer: 3000
                });
                LoadDataPermissions()
                formPermissions.resetFields();
                setLoadingPermissions(false)
                setOpenModalPermissions(false)
            })
        }

    }

    const showModalPermiss = (id) => {

        if (id === 0) {
            setOpenModalPermissions(true);
            setStatusPermissions(false);
        }
        else {
            setStatusPermissions(true);
            axiosClient.post('/GroupPermissions/GetGroupPermissionsAll', '', { headers: header }).then(resGroup => {
                const data = resGroup.data.filter(i => i.ID === id);
                formPermissions.setFieldsValue({
                    "ID": id,
                    "GroupName": data[0].GroupName
                })
            })
            setOpenModalPermissions(true);
        }
    }

    const renderPermissions = () => {
        return (
            <Form
                id="form-Permissions"
                form={formPermissions}
                onFinish={onFinishPermissions}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>

                <Form.Item rules={[
                    {
                        required: true,
                        message: "Chọn nhóm phân quyền",
                    },
                ]} label='Tên nhóm' name={'GroupName'} >
                    <Input />
                </Form.Item>
            </Form>
        )
    }
    const onFinishAccount = (values) => {

    }
    const renderAccount = () => {
        return (
            <Form
                id="form-Account"
                form={formAccount}
                onFinish={onFinishAccount}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>
                <Form.Item label='' name={'IDAccount'} >
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Nhập tên phân quyền",
                    },
                ]} name={'IDGroupPermission'} label='Phân quyền' >
                    <Input />
                </Form.Item>

            </Form>
        )
    }
    const onFinishDetailFuntion = (values) => {
        setLoadingDetailFuntion(true)
        if (statusDetailFuntion === false) {
            axiosClient.post('/DetailFunctions/AddDetailFunctions', values, { headers: header }).then(res => {
                if (res.status === 200) {
                    swal('Thành công!', {
                        icon: 'success',
                        timer: 3000
                    });
                    formDetailFuntion.resetFields();
                    LoadDataDetailFuntion();
                    setLoadingDetailFuntion(false)
                    setOpenModalDetailFuntion(false)
                }
            })
        }
        else {
            axiosClient.post('/DetailFunctions/UpdateDetailFunctions', values, { headers: header }).then(res => {
                if (res.status === 200) {
                    swal('Thành công!', {
                        icon: 'success',
                        timer: 3000
                    });
                    formDetailFuntion.resetFields();
                    LoadDataDetailFuntion();
                    setLoadingDetailFuntion(false)
                    setOpenModalDetailFuntion(false)
                }
            })
        }
    }


    const renderDetialFuntion = () => {
        return (
            <Form
                id="form-DetailFuntion"
                form={formDetailFuntion}
                onFinish={onFinishDetailFuntion}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name={'ID'} >
                    <Input />
                </Form.Item>
                <Form.Item hidden name={'IDFunctionGroup'} >
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Nhập tên phân quyền",
                    },
                ]} name={'DetailName'} label='Tên phân quyền' >
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: "Nhập Api",
                    },
                ]} name={'ApiName'} label='Api' >
                    <Input />
                </Form.Item>
            </Form>
        )
    }
    return (
        <div>
            <Card>
                <Tabs type="card" tabBarStyle={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}>
                    <Tabs.TabPane tab='Nhóm người dùng' key={1}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form
                                    form={formFilterDecentralization}
                                    name="basic"
                                    id="form-filter-account"
                                    onFinish={onFinishFilter}
                                    labelCol={{ span: 0 }}
                                    labelAlign="right"
                                    colon={false}
                                    wrapperCol={{
                                        span: 24,
                                    }}
                                >
                                    <Row gutter={[8, 8]}>

                                        <Col xs={24} xl={19} span={4}>
                                            <Form.Item name="ID">
                                                <Select defaultValue={"Chọn quyền"}>
                                                    <Option value={"default"}>Chọn quyền</Option>
                                                    {dataDecentralizationInit.map(r => (
                                                        <Option value={r.ID}>{r.FunctionName}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={5} span={3}>
                                            <Form.Item>
                                                <Button.Group>
                                                    <Button icon={<SearchOutlined />} form="form-filter-account" htmlType="submit" type="primary" style={{ backgroundColor: '#22B14C', color: 'white', borderRadius: 4 }} >Lọc</Button>
                                                    &nbsp;
                                                    <Button icon={<PlusOutlined />} type="primary" onClick={(e => showModalPermiss(0))} style={{ borderRadius: 4 }} >Thêm mới</Button>
                                                </Button.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="clearfix"></div>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} rowSelection={rowSelectionUserGroup} sticky columns={columnsUserGroup} dataSource={dataPermissions} />
                            </Col>
                        </Row>

                    </Tabs.TabPane>
                    <Tabs.TabPane tab='Chức năng' key={2}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form
                                    form={formFilterDecentralization}
                                    name="basic"
                                    id="form-filter-account"
                                    onFinish={onFinishFilter}
                                    labelCol={{ span: 0 }}
                                    labelAlign="right"
                                    colon={false}
                                    wrapperCol={{
                                        span: 24,
                                    }}
                                >
                                    <Row gutter={[8, 8]}>

                                        <Col xs={24} xl={19} span={4}>
                                            <Form.Item name="ID">
                                                <Select defaultValue={"Chọn quyền"}>
                                                    <Option value={"default"}>Chọn quyền</Option>
                                                    {dataDecentralizationInit.map(r => (
                                                        <Option value={r.ID}>{r.FunctionName}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={5} span={3}>
                                            <Form.Item>
                                                <Button.Group>
                                                    <Button icon={<SearchOutlined />} form="form-filter-account" htmlType="submit" type="primary" style={{ backgroundColor: '#22B14C', color: 'white', borderRadius: 4 }} >Lọc</Button>
                                                    &nbsp;
                                                    <Button icon={<PlusOutlined />} type="primary" onClick={(e => showModalDecentralization(0))} style={{ borderRadius: 4 }} >Thêm mới</Button>
                                                </Button.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="clearfix"></div>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <Table className="detail" tableLayout="fixed" expandable={{
                                    expandedRowRender: (record) => (
                                        <Table rowClassName={(record, index) => {
                                            return index % 2 === 0 ? "gray-color" : "";
                                        }} tableLayout="fixed" showHeader={false} className="detailFuntion" pagination={false} dataSource={detailFuntion(record.IDFunctionGroup)} columns={columnsDetail} />
                                    ),
                                    columnWidth: '4%',
                                    defaultExpandAllRows: true,
                                    expandIconAsCell: false,
                                    showExpandColumn: true,

                                }} sticky scroll={{ x: 1200 }} columns={columnsDecentralization} dataSource={dataDecentralization} />

                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab='Phân quyền nhóm người dùng' key={3}>
                        <Row gutter={16}>

                            <Col span={24}>
                                <Table style={{ display: 'block' }} expandable={{
                                    expandedRowRender: (record) => (
                                        <Table rowClassName={(record, index) => {
                                            return index % 2 === 0 ? "gray-color" : "";
                                        }} showHeader={false} className="detailPermiss" pagination={false} dataSource={detailFuntion(record.IDFunctionGroup)} columns={columnsDetailPermiss} />
                                    ),

                                    columnWidth: '4.2%',
                                    defaultExpandAllRows: true,
                                    expandIconAsCell: false,
                                    showExpandColumn: true,
                                }} scroll={{ x: 1200 }} sticky columns={columnPermissions} dataSource={dataDecentralization} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab='Phân quyền người dùng' key={4}>
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form
                                    form={formFilterDecentralization}
                                    name="basic"
                                    id="form-filter-account"
                                    onFinish={onFinishFilter}
                                    labelCol={{ span: 0 }}
                                    labelAlign="right"
                                    colon={false}
                                    wrapperCol={{
                                        span: 24,
                                    }}
                                >
                                    <Row gutter={[8, 8]}>

                                        <Col xs={24} xl={19} span={4}>
                                            <Form.Item name="ID">
                                                <Select defaultValue={"Chọn quyền"}>
                                                    <Option value={"default"}>Chọn quyền</Option>
                                                    {dataDecentralizationInit.map(r => (
                                                        <Option value={r.ID}>{r.FunctionName}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col xs={24} xl={5} span={3}>
                                            <Form.Item>
                                                <Button.Group>
                                                    <Button icon={<SearchOutlined />} form="form-filter-account" htmlType="submit" type="primary" style={{ backgroundColor: '#22B14C', color: 'white', borderRadius: 4 }} >Lọc</Button>
                                                    &nbsp;
                                                    <Button icon={<PlusOutlined />} type="primary" onClick={(e => showModalAccountPermiss(0))} style={{ borderRadius: 4 }} >Thêm mới</Button>
                                                </Button.Group>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <div className="clearfix"></div>
                                </Form>
                            </Col>
                            <Col span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} sticky columns={columnsAccountPermiss} dataSource={dataAccountPermiss} />
                            </Col>
                        </Row>
                    </Tabs.TabPane>
                </Tabs>
            </Card>
            <Modal
                width={600}
                open={openModalDecentralization}
                title={
                    <span>
                        {statusModalDecentralization === false ? 'Thêm mới phân quyền' : 'Cập nhật phân quyền'}
                    </span>
                }
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        Hủy
                    </Button>,
                    <Button form="form-Decentralization" type="primary" htmlType="submit" loading={loading}>
                        Lưu
                    </Button>,
                ]}
            >
                {loading ? (
                    <>
                        <Skeleton loading={loading} active />
                    </>
                ) : (
                    <>{renderDecentralization()}</>
                )}
            </Modal>
            <Modal
                width={600}
                open={openModalDetailFuntion}
                title={
                    <span>
                        {statusDetailFuntion === false ? 'Thêm mới chi tiết phân quyền' : 'Cập nhật chi tiết phân quyền'}
                    </span>
                }
                onOk={handleOkDetialFuntion}
                onCancel={handleCancelDetialFuntion}
                footer={[
                    <Button key="back" onClick={handleCancelDetialFuntion}>
                        Hủy
                    </Button>,
                    <Button form="form-DetailFuntion" type="primary" htmlType="submit" loading={loadingDetialFuntion}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingDetialFuntion ? (
                    <>
                        <Skeleton loading={loadingDetialFuntion} active />
                    </>
                ) : (
                    <>{renderDetialFuntion()}</>
                )}
            </Modal>
            <Modal
                width={600}
                open={openModalAccount}
                title={
                    <span>
                        {statusAccount === false ? 'Thêm mới quyền người dùng' : 'Cập nhật quyền người dùng'}
                    </span>
                }
                onOk={handleOkAccount}
                onCancel={handleCancelAccount}
                footer={[
                    <Button key="back" onClick={handleCancelAccount}>
                        Hủy
                    </Button>,
                    <Button form="form-Account" type="primary" htmlType="submit" loading={loadingAccount}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingAccount ? (
                    <>
                        <Skeleton loading={loadingAccount} active />
                    </>
                ) : (
                    <>{renderAccount()}</>
                )}
            </Modal>
            <Modal
                width={600}
                open={openModalPermissions}
                title={
                    <span>
                        {statusPermissions === false ? 'Thêm mới quyền ' : 'Cập nhật quyền'}
                    </span>
                }
                onOk={handleOkPermissions}
                onCancel={handleCancelPermissions}
                footer={[
                    <Button key="back" onClick={handleCancelPermissions}>
                        Hủy
                    </Button>,
                    <Button form="form-Permissions" type="primary" htmlType="submit" loading={loadingPermissions}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingPermissions ? (
                    <>
                        <Skeleton loading={loadingPermissions} active />
                    </>
                ) : (
                    <>{renderPermissions()}</>
                )}
            </Modal>
            <Modal
                width={600}
                open={openModalAccountPermiss}
                title={
                    <span>
                        {statusAccountPermiss === false ? 'Thêm mới' : 'Cập nhật'}
                    </span>
                }
                onOk={handleOkAccountPermiss}
                onCancel={handleCancelAccountPermiss}
                footer={[
                    <Button key="back" onClick={handleCancelAccountPermiss}>
                        Hủy
                    </Button>,
                    <Button form="form-AccountPermiss" type="primary" htmlType="submit" loading={loadingAccountPermiss}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingAccountPermiss ? (
                    <>
                        <Skeleton loading={loadingAccountPermiss} active />
                    </>
                ) : (
                    <>{renderAccountPermiss()}</>
                )}
            </Modal>
        </div >
    )
}
export default Decentralization;